import {
  Landmark,
  GitBranch,
  Target,
  Package,
  Users,
  Workflow,
  UserCog,
  ArrowUpRight,
} from "lucide-react";

const services = [
  {
    icon: Landmark,
    title: "Government Consulting",
    desc:
      "Proposal strategy, federal capture, and contract execution for agencies demanding precision.",
    span: "md:col-span-2 md:row-span-2",
    feature: true,
  },
  {
    icon: GitBranch,
    title: "Project Management",
    desc: "PMO-grade delivery across the full engagement lifecycle.",
  },
  {
    icon: Target,
    title: "Business Strategy",
    desc: "Board-level advisory to define positioning, growth, and execution.",
  },
  {
    icon: Package,
    title: "Product Procurement",
    desc: "Sourcing, vendor negotiation, and compliant product acquisition.",
    span: "md:col-span-2",
  },
  {
    icon: Workflow,
    title: "Agile & Scrum Mastery",
    desc: "Certified Scrum leadership turning backlogs into shipped outcomes.",
  },
  {
    icon: Users,
    title: "Temporary & Permanent Staffing",
    desc: "Vetted talent matched to mission-critical roles, on demand.",
  },
  {
    icon: UserCog,
    title: "Human Resources Consulting",
    desc: "Compliance, culture, and people strategy for growing organizations.",
    span: "md:col-span-2",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 md:py-40 bg-[#070d1a] border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div className="max-w-2xl">
            <p
              className="text-[11px] font-bold uppercase tracking-[0.32em] text-[#d4af37] mb-5 reveal"
              data-testid="services-overline"
            >
              <span className="gold-rule" /> Services
            </p>
            <h2
              className="font-serif-editorial text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] text-white reveal"
              data-testid="services-headline"
            >
              Seven disciplines.
              <br />
              <span className="italic text-[#d4af37]">One standard.</span>
            </h2>
          </div>
          <p className="text-slate-400 max-w-md reveal">
            Each engagement is led by senior operators with direct federal and
            enterprise experience—your competitive edge, delivered.
          </p>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-4 auto-rows-fr gap-px bg-white/[0.06] border border-white/10"
          data-testid="services-grid"
        >
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                className={`group relative bg-[#0a1324] hover:bg-[#0f1a2f] transition-colors duration-500 p-8 md:p-10 flex flex-col justify-between min-h-[240px] ${
                  s.span || ""
                } ${s.feature ? "md:min-h-[500px]" : ""} reveal`}
              >
                <div>
                  <Icon
                    size={s.feature ? 40 : 28}
                    className="text-[#d4af37] mb-6"
                    strokeWidth={1.2}
                  />
                  <h3
                    className={`font-serif-editorial text-white leading-tight ${
                      s.feature
                        ? "text-3xl md:text-4xl lg:text-5xl"
                        : "text-xl md:text-2xl"
                    }`}
                  >
                    {s.title}
                  </h3>
                  <p
                    className={`mt-4 text-slate-400 ${
                      s.feature ? "text-base md:text-lg max-w-md" : "text-sm"
                    }`}
                  >
                    {s.desc}
                  </p>
                </div>
                <div className="mt-8 flex items-center justify-between">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-slate-500">
                    0{i + 1}
                  </span>
                  <ArrowUpRight
                    size={18}
                    className="text-slate-600 group-hover:text-[#d4af37] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
